import { Pipe, PipeTransform } from '@angular/core';
import { GroupModel } from 'src/app/shared/store/group/types';

@Pipe({
    name: 'groupModelName',
    standalone: false
})
export class GroupModelNamePipe implements PipeTransform {
  transform(groups: GroupModel[]): string[] {
    return groups.map((obj) => obj.name);
  }
}
